<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Configuracion de accesos del sistema</h2>
    <MainAccess />
  </div>
</template>

<script>
import MainAccess from "@/components/Users/Access/MainAccess.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from '@/hisAcces';
export default {
  name: "AccessMain",
  components: {
    MainAccess,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
